<template>
	<div class="choose-actions">
		<egranty-section-divider
			:text="numberOfModules > 1 ? 'Działania programowe modułu ' + moduleNumber : 'Działania programowe projektu'"
			icon="flag"
			:show-print-info="showPrintInfo"
		/>

		<div class="action-cards-wrap" style="display: flex">
			<div
				v-for="(action,index) in current"
				:key="index"
				class="action-card"
			>

				<v-card class="choose-actions-card">
					<v-toolbar :color="getStatusColor(action)" dark class="toolbar-action-card">
						<h3>Działanie nr {{action.serialNumber}} {{getStatus(action)}}</h3>
					</v-toolbar>

					<div class="mt-3 ml-3 mr-3">
						<v-layout row mt-2 ml-4>
							<div>
								<strong>Nazwa:</strong> {{action.action}}
							</div>
						</v-layout>

						<v-layout row mt-2 ml-4>
							<div>
								<strong>Miejsce:</strong> {{action.place}}
							</div>
						</v-layout>

						<v-layout row mt-2 ml-4>
							<div>
								<strong>Opis:</strong> {{action.description}}
							</div>
						</v-layout>

						<choose-beneficiaries-read-only-view
							v-if="contestId !== null"
							v-model="action.beneficiariesData"
							:contestId="contestId"
						></choose-beneficiaries-read-only-view>

						<v-layout mt-2 ml-4>
							<div class="mb-3">
								<strong>Okresy realizacji:</strong>
								<div class="mt-2">
									<ul>
										<li class="ml-4" v-for="(dates, datesIndex) in action.realizationDates"
											:key='datesIndex'>
											{{datesIndex + 1}}. {{dates.start}} - {{dates.end}}
										</li>
									</ul>
								</div>
							</div>
						</v-layout>
					</div>
				</v-card>
			</div>
		</div>
	</div>
</template>

<script>
	import EgrantySectionDivider from "../../../../../genericComponents/EgrantySectionDivider";
	import ChooseBeneficiariesReadOnlyView from "./ChooseBeneficiariesReadOnlyView";

	export default {
		name: "ChooseActionsReadOnlyView",
		components: {
			ChooseBeneficiariesReadOnlyView,
			EgrantySectionDivider
		},
		data () {
			return {
				current: [],
				datesOpen: [],
			};
		},

		watch: {
			value: {
				immediate: true,
				handler (val) {
					if (val === undefined) {
						val = [];
					}
					this.current = [...val];
					this.current = this.current.sort((a, b) => a.serialNumber - b.serialNumber);
				},
			},
		},

		methods: {

			getStatusColor (action) {
				if (this.getStatus(action) === '(Usunięte)') {
					return "red lighten-2";
				}
				if (this.getStatus(action) === '(Nowe)') {
					return "green lighten-2";
				}
				if (this.getStatus(action) === '(Zmienione)') {
					return "blue lighten-2";
				}
				return "grey lighten";
			},

			getStatus (action) {
				if (this.oldVersion) {
					let found = this.oldVersion.find(x => x.serialNumber === action.serialNumber);
					if (!found) {
						return "(Nowe)";
					} else {
						action.id = 0;
						found.id = 0;
						if (JSON.stringify(action) !== JSON.stringify(found)) {
							return "(Zmienione)";
						}
					}
				}
				if (this.newVersion) {
					let found = this.newVersion.find(x => x.serialNumber === action.serialNumber);
					if (!found) {
						return "(Usunięte)";
					} else {
						action.id = 0;
						found.id = 0;
						if (JSON.stringify(action) !== JSON.stringify(found)) {
							return "(Zmienione)";
						}
					}
				}

				return "";
			}
		},

		props: {
			takenSerialNumbers: {},
			contestId: null,
			value: {},
			oldVersion: {},
			newVersion: {},
			moduleId: {},
			moduleNumber: {
				default: "",
			},
			numberOfModules: {
				default: 0,
			},
			showPrintInfo: {
				type: Boolean, default: false
			}
		},
	};
</script>

<style scoped>

	.choose-actions .theme--dark.v-btn:not(.v-btn--icon):not(.v-btn--flat) {
		margin-top: 20px;
		margin-bottom: 20px;
	}

	.choose-actions .v-input__control {
		margin-left: 20px;
		margin-right: 20px;
	}

	.choose-action-place {
		padding-left: 10px;
		padding-right: 10px;
	}

	.choose-actions-realization-date {
		padding-left: 10px;
		padding-right: 10px;
	}

	.grey {
		background-color: #0052A5 !important;
	}

	.action-cards-wrap {
		display: flex;
		flex-wrap: wrap;
		width: 100%;
	}

	.action-card {
		flex: 0 100%;
	}
	.choose-actions-card {
		height: 100%;
	}

	/*
		strong {
			font-size: 20px !important;
		}

		.application.mediumFont strong {
			font-size: 22px !important;
	}

		.application.largeFont strong {
			font-size: 24px !important;
	} */
</style>
